import React from 'react';
import { Link } from 'react-router-dom';

import './Anchor.scss';

const Anchor = ({ label, path }) => (
  <Link
    to={path}
    className="anchor"
  >
    {label}
  </Link>
);

export default Anchor;